import {PaginatedContent} from '../../../application/contentLoaders/paginatedContent';
import {ReadyProvider} from '../../../application/providers/readyProvider';
import {CommentLoader} from '../offer/commentLoader';
import '../user/confirmEmail';
import {CountdownTimer} from './timers/CountdownTimer';
import {Form} from '../../../application/forms/form';
import {TopOfferLoader} from './loaders/topOfferLoader';

ReadyProvider.executeOnReady(() => {
    let contentElement = document.querySelector('[data-content="offers"]');

    if (contentElement) {
        let paginatedContent = new PaginatedContent(contentElement);

        paginatedContent.setLoadElementCallback(function (element) {
            let timer = element.querySelector('[data-init="timer"]');

            if (timer) {
                new CountdownTimer(timer);
            }
        });

        CommentLoader.initToggleButtons(contentElement);
        TopOfferLoader.initToggleButtons(contentElement);

        new Form(document.querySelector('[data-comment="form"]'));

        Array.from(contentElement.querySelectorAll('[data-init="timer"]')).forEach((element) => {
            new CountdownTimer(element);
        });
    }
});
